import { queryOptions } from "@tanstack/react-query";
import { type Api, listAppFeatures, listBillingCatalog } from "api-client";

export type AdminBillingProduct = Api.ListBillingCatalog.Output.Product;
export type AdminBillingPrice = Api.ListBillingCatalog.Output.Price;
export type AppFeature = Api.ListAppFeatures.Output.Feature;

const ADMIN_BILLING_QUERY_GC_TIME = 5 * 60_000;

export function billingCatalogQueryOptions() {
  return queryOptions({
    queryKey: ["admin", "billing-catalog"],
    gcTime: ADMIN_BILLING_QUERY_GC_TIME,
    queryFn: async () => {
      const response = await listBillingCatalog();
      return response.data.data;
    },
  });
}

export function appFeaturesQueryOptions() {
  return queryOptions({
    queryKey: ["admin", "app-features"],
    gcTime: ADMIN_BILLING_QUERY_GC_TIME,
    queryFn: async () => {
      const response = await listAppFeatures();
      return response.data.data;
    },
  });
}
